export default "__VITE_ASSET__0378c0c8__"